export const isRequired =
  (message: string = 'This field is required.') =>
  (val: string) =>
    (val && val.trim().length > 0) || message

export const hasMaxLength =
  (max: number, message: string = `This field must be fewer than ${max} characters.`) =>
  (val: string) =>
    !val || val.trim().length <= max || message

export const hasMinLength =
  (min: number, message: string = `This field must be more than ${min} characters.`) =>
  (val: string) =>
    !val || val.trim().length >= min || message

export const hasMaxValue =
  (max: number, message: string = `This field must be less than ${max}.`) =>
  (val: number) =>
    !val || val <= max || message

export const hasMinValue =
  (min: number, message: string = `This field must be more than ${min}.`) =>
  (val: number) =>
    !val || val >= min || message

export const hasExactLength =
  (len: number, message: string = `This field must be exactly ${len} characters.`) =>
  (val: string) =>
    !val || val.trim().length === len || message

export const isNotNullOrEmpty =
  (message: string = 'This field is required.') =>
  (val: any) =>
    (val !== null && val !== undefined && val !== '') || message

export const isDateNotInFuture =
  (message: string = 'Date cannot be in the future.') =>
  (val: string | Date) => {
    if (!val) return true
    const dateVal = typeof val === 'string' ? new Date(val) : val
    return dateVal <= new Date() || message
  }

// An address counts only once a suggestion with coordinates was picked (RF-064). The typed text on its own
// would leave the report without a location, so `hasCoordinates` is checked at validation time.
export const isAddressPicked =
  (hasCoordinates: () => boolean, message: string = 'Pick an address from the suggestions.') =>
  (val: unknown) =>
    !val || hasCoordinates() || message
